// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list li[data-v-67a6e046]:not(:last-child){margin-bottom:7px}", ""]);
// Exports
module.exports = exports;
